<template>
  <div v-if="containers" data-structure="structure">
    <ProgressCharts :location="location" :containers="containers" :courseCreditsMax="parseInt(structure.credits)" />
    <UnitGroup v-for="container in containers" :key="container.title+'-'+container.order"
      :groupTitle="container.title" :container="container"
      :location="location+'>'+container.title+'-'+container.order"
      :mandatory="checkMandatory(container)" />
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { dynamicSort } from 'common/helpers/dynamic-sort.js'
import UnitGroup from './UnitGroup.vue'
import ProgressCharts from './ProgressCharts.vue'

export default {
  name: 'CourseStructure',
  data: function () {
    return {
      credits: 0
    }
  },
  props: {
    structure: {
      type: Object,
      required: true
    },
    location: {
      type: String,
      required: true
    },
    mandatory: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    ...mapState({}),
    containers: function () {
      return this.structure.containers.sort(dynamicSort('order'))
    }
  },
  methods: {
    checkMandatory(data) {
      if (this.mandatory && data.connector == 'AND') {
        return true
      } else {
        return false
      }
    }
  },
  watch: {},
  components: { UnitGroup, ProgressCharts }
}
</script>

